import React, { memo } from 'react';

import { Typography } from 'antd';

import ProfileItem from '../../../../components/ProfileItem/ProfileItem';
import { DEFAULT_AVATAR } from '../../../../shared/data';
import { timeAgo } from '../../../../shared/utils';
import { IMango } from '../../../../types/feedTypes';
import {
  ITQShoutout,
  UserProfileTabItemTypeValue,
} from '../../../../types/tqConnectTypes/user';
import MangoTitle from '../../../Feed/Posts/MangoTitle';
import ShoutoutCardBottomActions from './ShoutoutCardBottomActions';
import ShoutoutHeaderTitle from './ShoutoutHeaderTitle';
import ShoutoutPreview from './ShoutoutPreview';

interface Props {
  type: UserProfileTabItemTypeValue;
  shoutout: ITQShoutout;
  canPostToCommunity: boolean;
}

const ShoutoutCard: React.FC<Props> = ({
  type,
  shoutout,
  canPostToCommunity,
}) => {
  const { from, to, channels, coverImage, category, description, createdAt } =
    shoutout;

  return (
    <div className="shoutout-card">
      <div className="card__header">
        <ProfileItem
          className="card__header__content"
          avatar={from?.profilePicUrl || DEFAULT_AVATAR}
          avatarSize={40}
          title={
            <ShoutoutHeaderTitle
              from={from}
              to={to}
              type="given"
              canOpenProfile
            />
          }
          subtitle={
            <div className="content__subtitle">
              {timeAgo(createdAt)}
              &nbsp;•&nbsp;
              {channels?.length ? (
                <MangoTitle
                  mangoes={channels.map(
                    (ch) =>
                      ({
                        _id: ch._id,
                        title: ch.name,
                      }) as IMango,
                  )}>
                  <Typography.Text type="secondary" style={{ fontWeight: 400 }}>
                    Posted in
                  </Typography.Text>{' '}
                </MangoTitle>
              ) : (
                <Typography.Text
                  className="content__subtitle__visibility"
                  type="secondary">
                  Profile only
                </Typography.Text>
              )}
            </div>
          }
          titleStyle={{ fontWeight: 400 }}
          subtitleStyle={{ width: '100%', cursor: 'auto' }}
        />
      </div>

      <ShoutoutPreview
        coverImage={coverImage}
        category={category}
        description={description}
      />

      <ShoutoutCardBottomActions
        type={type}
        shoutout={shoutout}
        canPostToCommunity={canPostToCommunity}
      />
    </div>
  );
};

export default memo(ShoutoutCard);
